// extracted by mini-css-extract-plugin
export var container = "_4t-0";
export var icon = "_4t-1";
export var text = "_4t-2";